/* Base translations · Analytics page and observations — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): analytics, obs. */
export const I18N_BASE_ANALYTICS_PAGE = {
  en: {
    analytics: {
      title: "Analytics",
      subtitle: "Financial statement analytics for this engagement",
      sourceLabel: "Source", sourceGl: "Main GL", sourceTb: "Trial Balance upload (no GL loaded)", sourceNone: "No data loaded",
      noPriorYear: "No prior-year data",
      priorYearTotal: "Prior year",
      revenue: "Revenue",
      expenses: "Expenses",
      balance: "Balance Sheet",
      monthly: "Monthly trend",
      yoy: "YoY growth",
      topCustomers: "Top customers",
      concentration: "Concentration",
      cutoff: "Cut-off (±5 days of period end)",
      momVariance: "Month-over-month variance",
      benford: "Benford's Law — first digit distribution",
      benfordScore: "Benford deviation",
      duplicates: "Potential duplicate invoices",
      roundNumbers: "Round-number entries",
      weekend: "Weekend postings",
      aging: "Aging summary",
      dormant: "Dormant accounts (180+ days)",
      negative: "Negative balance flags",
      genObs: "Generate AI observations",
      obsTitle: "AI-generated observations",
      obsTitleStat: "Statistical observations — no AI used",
    },
    obs: {
      title: "Observations",
      addBtn: "Add observation",
      col: { ref: "Ref", desc: "Description", type: "Type", amount: "Amount",
              assertion: "Assertion", wp: "WP ref", status: "Status", actions: "" },
      type: { misstatement: "Misstatement", deficiency: "Control deficiency",
                disclosure: "Disclosure", other: "Other matter" },
      status: { open: "Open", cleared: "Cleared", sent: "Sent" },
      sendMs: "Send to misstatements",
      sendDef: "Send to deficiency log",
      sentToMs: "Sent to misstatements",
      empty: "No observations yet.",
      new: {
        title: "New observation",
        save: "Save observation",
        created: "Observation added",
        descRequired: "Description is required.",
        wpPlaceholder: "e.g. 1203-04.05",
      },
    },
  },
  ar: {
    analytics: {
      sourceLabel: "المصدر", sourceGl: "الأستاذ العام الرئيسي", sourceTb: "ميزان المراجعة المرفوع (لا يوجد أستاذ عام)", sourceNone: "لا توجد بيانات",
      noPriorYear: "لا توجد بيانات سنة سابقة",
      priorYearTotal: "السنة السابقة",
      title: "التحليلات",
      subtitle: "تحليلات القوائم المالية لهذه المهمة",
      revenue: "الإيرادات",
      expenses: "المصروفات",
      balance: "قائمة المركز المالي",
      monthly: "الاتجاه الشهري",
      yoy: "النمو السنوي",
      topCustomers: "أهم العملاء",
      concentration: "التركز",
      cutoff: "الفصل الزمني (±5 أيام من نهاية الفترة)",
      momVariance: "التغير الشهري",
      benford: "قانون بنفورد — توزيع أول رقم",
      benfordScore: "انحراف بنفورد",
      duplicates: "فواتير مكررة محتملة",
      roundNumbers: "قيود بأرقام مقربة",
      weekend: "قيود عطلة نهاية الأسبوع",
      aging: "ملخص الأعمار",
      dormant: "حسابات خاملة (+180 يوم)",
      negative: "أرصدة سالبة",
      genObs: "توليد ملاحظات الذكاء الاصطناعي",
      obsTitle: "ملاحظات الذكاء الاصطناعي",
      obsTitleStat: "ملاحظات إحصائية — دون استخدام الذكاء الاصطناعي",
    },
    obs: {
      title: "الملاحظات",
      addBtn: "إضافة ملاحظة",
      col: { ref: "المرجع", desc: "الوصف", type: "النوع", amount: "المبلغ",
              assertion: "الإقرار", wp: "مرجع ورقة العمل", status: "الحالة", actions: "" },
      type: { misstatement: "تحريف", deficiency: "قصور في الضوابط",
                disclosure: "إفصاح", other: "أمر آخر" },
      status: { open: "مفتوح", cleared: "مُعالَج", sent: "مُرسَل" },
      sendMs: "إرسال إلى ملخص التحريفات",
      sendDef: "إرسال إلى سجل أوجه القصور",
      sentToMs: "تم الإرسال إلى ملخص التحريفات",
      empty: "لا توجد ملاحظات بعد.",
      new: {
        title: "ملاحظة جديدة",
        save: "حفظ الملاحظة",
        created: "تمت إضافة الملاحظة",
        descRequired: "الوصف مطلوب.",
        wpPlaceholder: "مثال: 1203-04.05",
      },
    },
  },
};

export default I18N_BASE_ANALYTICS_PAGE;
